import { combineReducers } from "redux";
import user, { userState, userRole } from "./settings/user";
import settings from "./settings";
import favorites from "./settings/favorites";
import notifications from "./settings/notifications";
import dom from "./domReducer";
import modal from "./modalReducer";
import categories from "./timeInput/categories";
import accounts from "./timeInput/accounts";
import productGroups from "./timeInput/productGroups";
import historyFilters from "./history/historyFilters";
import entries from "./history/entries";
import locations from "./timeInput/locations";
import opportunities from "./timeInput/opportunities";
import interlock from "./timeInput/interlock";
import serviceRequests from "./timeInput/serviceRequests";
import dates from "./timeInput/dates";
import roles from "./settings/roles";
import entry from "./entryReducer";
import reportError from "./reportError";
import MentorTimeTrackerApi from "../lib/MentorTimeTrackerApi";
import apiUrls from "../urls";

function api (state = false, action) {
  switch (action.type) {
  case "SET_API_TOKENS":
    return MentorTimeTrackerApi(
      apiUrls.API,
      action.payload.auth0
    );

  case "LOGOUT_USER":
    return false;

  default:
    return state;
  }
}

function apiTokens (state = false, action) {
  switch (action.type) {
  case "SET_API_TOKENS":
    return action.payload.auth0;
  default:
    return state;
  }
}

export default combineReducers({
  accounts,
  api,
  apiTokens,
  categories,
  dates,
  dom,
  entries,
  entry,
  favorites,
  historyFilters,
  locations,
  modal,
  notifications,
  opportunities,
  interlock,
  productGroups,
  serviceRequests,
  roles,
  settings,
  user,
  userRole,
  userState,
  reportError
});



// WEBPACK FOOTER //
// ./app/reducers/reducers.js